var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.courses.items),function(item){return _c('div',{key:item.id},[_c('router-link',{attrs:{"to":{ name: 'course', params: { id: item.id } }}},[_vm._v("\n      "+_vm._s(item.title)+"\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }